import Vue from 'vue'
import Vuex from 'vuex'
import { SET_DOCS, SET_EO_ID } from './mutations.types'
import { GET_DOCS } from './actions.types'
import ApiService from '../common/api.service'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    eoId: false,
    docs: false
  },
  mutations: {
    [SET_EO_ID] (state, value) {
      state.eoId = value
    },
    [SET_DOCS] (state, value) {
      state.docs = value
    }
  },
  actions: {
    [GET_DOCS] ({ state, commit }) {
      return ApiService.query('/api/ekis/ekis-go/volunteer?eoId=' + state.eoId).then((res) => {
        if (res.data.response === 'success') {
          commit(SET_DOCS, res.data.data)
        } else {
          commit(SET_DOCS, [])
        }
      }
      ).catch(() => {
        commit(SET_DOCS, [])
      })
    }
  },
  modules: {
  }
})
